/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { SequencesAlignPayload } from './SequencesAlignPayload';
import {
    SequencesAlignPayloadFromJSON,
    SequencesAlignPayloadFromJSONTyped,
    SequencesAlignPayloadToJSON,
} from './SequencesAlignPayload';

/**
 * 
 * @export
 * @interface SequencesAlignResponse
 */
export interface SequencesAlignResponse {
    /**
     * 
     * @type {Array<Message>}
     * @memberof SequencesAlignResponse
     */
    messages?: Array<Message>;
    /**
     * 
     * @type {SequencesAlignPayload}
     * @memberof SequencesAlignResponse
     */
    payload?: SequencesAlignPayload;
}

/**
 * Check if a given object implements the SequencesAlignResponse interface.
 */
export function instanceOfSequencesAlignResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SequencesAlignResponseFromJSON(json: any): SequencesAlignResponse {
    return SequencesAlignResponseFromJSONTyped(json, false);
}

export function SequencesAlignResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequencesAlignResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messages': !exists(json, 'messages') ? undefined : ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'payload': !exists(json, 'payload') ? undefined : SequencesAlignPayloadFromJSON(json['payload']),
    };
}

export function SequencesAlignResponseToJSON(value?: SequencesAlignResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messages': value.messages === undefined ? undefined : ((value.messages as Array<any>).map(MessageToJSON)),
        'payload': SequencesAlignPayloadToJSON(value.payload),
    };
}

